import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (href: string) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-background-50 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}
              className="flex items-center gap-2 mb-4 cursor-pointer"
            >
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-foreground-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-50 whitespace-nowrap">
                黑料官网
              </span>
            </a>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              {footerData.description}
            </p>
          </div>

          {footerData.sections.map((section) => (
            <div key={section.title}>
              <h3 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
                {section.title}
              </h3>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                      className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
              合作伙伴
            </h3>
            <p className="text-sm text-foreground-600">
              暂无具体合作伙伴信息
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            {footerData.copyright}
          </p>
          <p className="text-xs text-foreground-700">
            本站内容仅供娱乐参考，不构成任何投资或消费建议
          </p>
        </div>
      </div>
    </footer>
  );
}